import { isEmpty } from 'lodash';
import { type UseQueryResult, useQuery } from 'react-query';
import {
  PsuAwardApprovalService,
  // eslint-disable-next-line camelcase
  type PagedResultDto_PsuAwardListDto,
} from '../../services/wealthlane-award-services';
import { type TableParamsType } from '../../types/common';

const useGetPsuAwardsParticipantApprovalList = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  tableInfo: TableParamsType
): UseQueryResult<
  // eslint-disable-next-line camelcase
  PagedResultDto_PsuAwardListDto | undefined,
  unknown
> => {
  const {
    approvalStatusId,
    optionAcceptance: psuAcceptance,
    fromDate,
    toDate,
    createdFromDate,
    createdToDate,
    grantFromDate,
    grantToDate,
    filter,
    sorting,
    skipCount,
    maxResultCount,
    employeeStatusId,
    _force,
  } = tableInfo;
  const psuStatus = 0;

  const PsuAwardsParticipantApprovalData = useQuery(
    [
      'getPsuAwardsParticipantApprovalList',
      approvalStatusId,
      fromDate,
      toDate,
      employeeStatusId,
      psuStatus,
      psuAcceptance,
      createdFromDate,
      createdToDate,
      grantFromDate,
      grantToDate,
      filter,
      sorting,
      skipCount,
      maxResultCount,
      _force,
    ],
    async () => {
      return await handleRequest(
        PsuAwardApprovalService.getApiAwardApiAppPSUAwardApprovalPSUAwardList(
          !isEmpty(approvalStatusId) ? approvalStatusId : [0],
          fromDate,
          toDate,
          employeeStatusId ?? [0],
          psuStatus,
          psuAcceptance,
          createdFromDate,
          createdToDate,
          grantFromDate,
          grantToDate,
          filter,
          sorting,
          skipCount,
          maxResultCount
        )
      );
    }
  );

  return PsuAwardsParticipantApprovalData;
};

export default useGetPsuAwardsParticipantApprovalList;
